import { __decorate, __extends } from "tslib";
import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { getConfig, update } from '../../api/config';
import { list as homeWoundList } from '../../api/homeWounds';
import { list as productList } from '../../api/products';
import { Button } from '../../components/Button';
import { DateSquare } from '../../components/DateSquare';
import { Dropdown } from '../../components/Dropdown';
import { SpinnerBlock } from '../../components/Spinner';
import { WoundItem } from '../../components/WoundItem';
import { CloseIcon } from '../../icons/CloseIcon';
import { WoundsHomeDetailsModal } from '../../modules/wounds/WoundsHomeDetailsModal';
import S from './Home.styl';
var HomeView = /** @class */ (function (_super) {
    __extends(HomeView, _super);
    function HomeView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            loading: false,
            featuredProductError: false,
            products: [],
            wounds: [],
            showWoundModal: false,
            visionTitleError: false,
            visionContentError: false,
        };
        _this.onProductSelected = function (product) {
            var _a;
            if (!((_a = _this.state.featuredProductIds) === null || _a === void 0 ? void 0 : _a.find(function (p) { return p === product.id; }))) {
                var featured = _this.state.featuredProductIds;
                if (featured) {
                    featured === null || featured === void 0 ? void 0 : featured.push(product.id || 0);
                }
                else {
                    featured = [product.id || 0];
                }
                _this.setState({
                    featuredProductIds: featured,
                });
            }
        };
        _this.getProduct = function (id) {
            var _a;
            return (_a = _this.state.products) === null || _a === void 0 ? void 0 : _a.find(function (p) { return p.id === id; });
        };
        _this.onRemoveProduct = function (id) {
            var _a;
            var featured = (_a = _this.state.featuredProductIds) === null || _a === void 0 ? void 0 : _a.filter(function (fId) { return fId !== id; });
            _this.setState({
                featuredProductIds: featured,
            });
        };
        _this.createAction = function () {
            _this.setState({
                editWound: undefined,
                showWoundModal: true,
            });
        };
        _this.onUpdate = function () {
            _this.fetchData();
        };
        _this.onCloseAdd = function () {
            _this.setState({
                showWoundModal: false,
            });
        };
        _this.isUpdatedAdd = function () {
            _this.setState({
                showWoundModal: false,
            });
            _this.fetchData();
        };
        _this.isEditClicked = function (wound) {
            _this.setState({
                editWound: wound,
                showWoundModal: true,
            });
        };
        _this.onChangeAction = function (e) {
            var name = e.currentTarget.name;
            if (name === 'visionTitle') {
                _this.setState({ visionTitleError: false });
            }
            if (name === 'visionContent') {
                _this.setState({ visionContentError: false });
            }
        };
        return _this;
    }
    HomeView.prototype.onSubmit = function (event) {
        var _this = this;
        var _a;
        event.preventDefault();
        var valid = true;
        var ids = this.state.featuredProductIds;
        if (!ids || ids.length === 0) {
            this.setState({ featuredProductError: true });
            valid = false;
        }
        if (!valid) {
            return;
        }
        var request = {
            featuredProductIds: (_a = this.state.featuredProductIds) === null || _a === void 0 ? void 0 : _a.join(','),
        };
        this.setState({ loading: true });
        update(request).then(function (_) {
            _this.fetchData();
        }).catch(function (error) {
            alert(error.toString());
            throw error;
        });
    };
    HomeView.prototype.onSubmitVision = function (event) {
        var _this = this;
        event.preventDefault();
        var elements = event.currentTarget.elements;
        var valid = true;
        var visionTitle = elements.visionTitle.value;
        var visionContent = elements.visionContent.value;
        if (visionTitle.length === 0) {
            this.setState({ visionTitleError: true });
            valid = false;
        }
        if (visionContent.length === 0) {
            this.setState({ visionContentError: true });
            valid = false;
        }
        if (!valid) {
            return;
        }
        var request = {
            visionHomeTitle: visionTitle,
            visionHomeContent: visionContent,
        };
        this.setState({ loading: true });
        update(request).then(function (_) {
            _this.fetchData();
        }).catch(function (error) {
            alert(error.toString());
            throw error;
        });
    };
    HomeView.prototype.componentDidMount = function () {
        var store = this.props.store;
        if (store) {
            this.fetchData();
        }
    };
    HomeView.prototype.fetchData = function () {
        this.setState({ loading: true });
        this.getProducts();
        this.getWounds();
        this.getConfig();
    };
    HomeView.prototype.getProducts = function () {
        var _this = this;
        productList().then(function (products) {
            _this.setState({
                products: (products === null || products === void 0 ? void 0 : products.items) || [],
            });
        }).catch(function (error) {
            alert(error.toString());
            throw error;
        });
    };
    HomeView.prototype.getWounds = function () {
        var _this = this;
        homeWoundList().then(function (products) {
            _this.setState({
                wounds: (products === null || products === void 0 ? void 0 : products.items) || [],
            });
        }).catch(function (error) {
            alert(error.toString());
            throw error;
        });
    };
    HomeView.prototype.getConfig = function () {
        var _this = this;
        getConfig().then(function (result) {
            _this.setState({
                loading: false,
                config: result,
                featuredProductIds: result === null || result === void 0 ? void 0 : result.featuredProductIds,
            });
        }).catch(function (error) {
            alert(error.toString());
            throw error;
        });
    };
    HomeView.prototype.render = function () {
        var _this = this;
        var _a, _b;
        var _c = this, props = _c.props, state = _c.state;
        var loading = state.loading, wounds = state.wounds, config = state.config;
        var i18n = props.store.i18n;
        var todayDate = new Date();
        return (React.createElement("div", { className: S.homeView },
            React.createElement("div", { className: S.homeHeaderContainer },
                React.createElement(DateSquare, { className: S.dateSquare, date: todayDate, size: 40 }),
                React.createElement("h1", { className: "moduleTitle" }, i18n.homeTitle),
                React.createElement("div", { className: S.dayNotesContainer },
                    React.createElement("span", { className: S.dayNotesDate }, i18n.formatMediumDate(todayDate)))),
            React.createElement("hr", { className: "moduleSeparator" }),
            React.createElement("div", { className: S.homeMainBox }, loading ?
                React.createElement(SpinnerBlock, null)
                :
                    React.createElement(React.Fragment, null,
                        React.createElement("form", { className: "" + S.addDialogContent, method: "get", action: "/", onSubmit: this.onSubmit, noValidate: true },
                            React.createElement("div", null,
                                React.createElement("h2", null, i18n.homeFeatured),
                                React.createElement(Dropdown, { maxHeight: 190, isFixed: true, className: "modalDropDown", boxClass: "modalDropDownBox", label: "" + i18n.inputChoose },
                                    React.createElement(Dropdown.List, null, (_a = this.state.products) === null || _a === void 0 ? void 0 : _a.map(function (product, index) { return (React.createElement(Dropdown.Item, { key: index, data: "product", autoClose: true, onClick: function (_) { return _this.onProductSelected(product); } }, product === null || product === void 0 ? void 0 : product.title)); }))),
                                React.createElement("div", { className: S.productList }, (_b = this.state.featuredProductIds) === null || _b === void 0 ? void 0 : _b.map(function (id, index) {
                                    var _a;
                                    return (React.createElement("div", { className: S.productSelected, key: index },
                                        React.createElement("span", null, (_a = _this.getProduct(id)) === null || _a === void 0 ? void 0 : _a.title),
                                        React.createElement("span", { onClick: function (_) { return _this.onRemoveProduct(id); } },
                                            React.createElement(CloseIcon, { className: S.productClose, width: 16, height: 16, color: 'white' }))));
                                })),
                                React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.featuredProductError ? 'inputErrorActive' : '') }, i18n.validationFeaturedError)),
                            React.createElement(Button, { className: "primaryButton fullwidthButton " + S.homeButton, type: "submit", spinner: loading }, i18n.actionUpdate)))),
            React.createElement("hr", { className: "moduleSeparator" }),
            React.createElement("div", { className: S.homeMainBox }, loading ?
                React.createElement(SpinnerBlock, null)
                :
                    React.createElement(React.Fragment, null,
                        React.createElement("form", { className: "" + S.addDialogContent, method: "get", action: "/", onSubmit: this.onSubmitVision, noValidate: true },
                            React.createElement("div", null,
                                React.createElement("h2", null, i18n.homeVision),
                                React.createElement("p", { className: "formSubtitle" }, i18n.inputTitlePlaceholder),
                                React.createElement("div", { className: S.addInputWrapper },
                                    React.createElement("label", { className: S.addInputTitle }, i18n.inputTitlePlaceholder),
                                    React.createElement("input", { className: S.addInput + " textInput", name: "visionTitle", onInput: this.onChangeAction, placeholder: i18n.inputTitlePlaceholder, defaultValue: config === null || config === void 0 ? void 0 : config.visionHomeTitle })),
                                React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.visionTitleError ? 'inputErrorActive' : '') }, i18n.validationTitleError),
                                React.createElement("p", { className: "formSubtitle" }, i18n.inputTitleContent),
                                React.createElement("div", { className: S.addInputWrapper },
                                    React.createElement("label", { className: S.addInputTitle }, i18n.inputTitlePlaceholder),
                                    React.createElement("input", { className: S.addInput + " textInput", name: "visionContent", onInput: this.onChangeAction, placeholder: i18n.inputTitlePlaceholder, defaultValue: config === null || config === void 0 ? void 0 : config.visionHomeContent })),
                                React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.visionContentError ? 'inputErrorActive' : '') }, i18n.validationContentError)),
                            React.createElement(Button, { className: "primaryButton fullwidthButton " + S.homeButton, type: "submit", spinner: loading }, i18n.actionUpdate)))),
            React.createElement("hr", { className: "moduleSeparator" }),
            React.createElement("div", { className: S.woundsHeaderActions },
                React.createElement("h2", null, i18n.woundsTitle),
                React.createElement(Button, { className: "primaryButton " + S.addButton, type: "button", onClick: this.createAction }, i18n.actionCreate)),
            React.createElement("div", { className: S.woundsMainBox }, loading ?
                React.createElement(SpinnerBlock, null)
                :
                    React.createElement(React.Fragment, null,
                        React.createElement("div", { className: S.woundsHeader },
                            React.createElement("div", { className: S.tableCell + " imageCell" }, i18n.woundsItemImage),
                            React.createElement("div", { className: S.tableCell }, i18n.woundsItemTitle),
                            React.createElement("div", { className: S.action }, i18n.woundsAction)),
                        React.createElement("div", { className: S.woundsUserList }, wounds.map(function (wound, i) { return (React.createElement(WoundItem, { key: i, wound: wound, isUpdated: _this.onUpdate, isEditClicked: _this.isEditClicked })); })))),
            this.state.showWoundModal &&
                React.createElement(WoundsHomeDetailsModal, { onClose: this.onCloseAdd, isUpdated: this.isUpdatedAdd, homeWound: this.state.editWound })));
    };
    __decorate([
        action.bound
    ], HomeView.prototype, "onSubmit", null);
    __decorate([
        action.bound
    ], HomeView.prototype, "onSubmitVision", null);
    HomeView = __decorate([
        inject('store'),
        observer
    ], HomeView);
    return HomeView;
}(React.Component));
export { HomeView };
